var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlog = function SvgBlog(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21740_19263)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73037 12.9082L10.2333 11.0303C10.2787 10.8607 10.368 10.7061 10.4922 10.5819L20.0749 0.999898C20.4655 0.609398 21.0986 0.609411 21.4891 0.999928L22.9033 2.41413C23.2938 2.80466 23.2938 3.43785 22.9033 3.82836L13.3312 13.3997C13.2022 13.5287 13.0403 13.62 12.8631 13.6636L10.9352 14.1379C10.1966 14.3197 9.53358 13.6429 9.73037 12.9082ZM13 2C13.5523 2 14 2.44772 14 3C14 3.55228 13.5523 4 13 4H4C2.89543 4 2 4.89543 2 6V14.35V16.4V19.1716V22L4 20L4.72132 19.2787C5.28393 18.7161 6.04699 18.4 6.84264 18.4H17.9C19.0046 18.4 19.9 17.5046 19.9 16.4V11C19.9 10.4477 20.3477 10 20.9 10C21.4523 10 21.9 10.4477 21.9 11V16.4C21.9 18.6091 20.1091 20.4 17.9 20.4H7.67107C6.87542 20.4 6.11236 20.7161 5.54975 21.2787L3.41421 23.4142C2.84222 23.9862 1.98198 24.1573 1.23463 23.8478C0.487284 23.5382 0 22.8089 0 22V16.4V14.35V6C0 3.79086 1.79086 2 4 2H13Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21740_19263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blog.f3397abdfa56b13f3d6ed9717bb9e756.svg";